import 'fetch-polyfill';
import axios from 'axios';
import API from '../../APIconfig';
import {
  GET_BALANCE,
  NET_BANKING_OPTIONS,
  APPLY_PROMO_CODE,
  VALIDATE_PROMO_CODE,
  APPLY_FREE_FUND_CODE,
  RESET_FREE_FUND_CODE,
  RESET_PROMO_CODE,
  ADDMONEY_INIT,
  TOGGLE_FREEFUND_CODE,
  TOGGLE_PROMO_CODE,
  GET_WITHDRAW_FEE,
  DELETE_WITHDRAW_FEE,
  SELECT_BANK_ACCOUNT,
  WITHDRAW_SUCCESS,
  CARD_BINS
} from './PaymentConstants';

import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from '../async/asyncActions';

import {
  toastr
} from 'react-redux-toastr';

import { GENERATE_OTP } from '../OTP/OTPconstants';

import { closeModal } from '../modals/modalActions';

export const toggleFreefundCodeForm = () => {
  return {
    type: TOGGLE_FREEFUND_CODE,
  }
}

export const togglePromoCodeForm = () => {
  return {
    type: TOGGLE_PROMO_CODE,
  }
}

export const getBalance = (isWithdrawable, csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Fetching your balance . . .', false, 'getbalance'));
      const reqObject = {
        method: API.payment.getBalance.method,
        credentials: 'include',
        mode: 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const balance = await fetch(`${API.payment.getBalance.url}?isWithdrawable=${isWithdrawable || false}&fcChannel=1`, reqObject).then(response => response.json());

      dispatch({
        type: GET_BALANCE,
        payload: balance,
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};


export const getNetBankingOptions = (csrfRequestIdentifier) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("", false, 'netbank'));
      const reqObject = {
        method: API.payment.netBankingOptions.method,
        credentials: 'include',
        mode: 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const banks = await fetch(API.payment.netBankingOptions.url, reqObject).then(response => response.json());

      dispatch({
        type: NET_BANKING_OPTIONS,
        payload: banks,
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

export const applyFreeFundCode = (couponCode, amount, csrfRequestIdentifier, callback) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Applying Frrefund code . . .', false, 'applyfreefundcode'));
      const URL = `${API.payment.applyFreeFund.url}`;

      let formData = new FormData();
      formData.append('lookupID', '');
      formData.append('couponCode', couponCode);
      formData.append('productType', "credits");
      formData.append('fcChannel', 1);

      const reqObject = {
        method: API.payment.applyFreeFund.method,
        credentials: 'include',
        mode: 'cors',
        body: formData,
        headers: new Headers({
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const promo = await fetch(URL, reqObject).then(response => response.json());

      if (promo.errorCode && promo.errors) {
        toastr.error('Error', promo.errors);
      }

      if (promo.successMsg === 'success' && promo.status === 'success') {
        toastr.success('Promocode service', 'Congratulations! Your freefund code is applied successfully and wallet is updated.');
      }

      // update the balance
      dispatch(getBalance(false, csrfRequestIdentifier));

      dispatch({
        type: APPLY_FREE_FUND_CODE,
        payload: promo,
      });
      dispatch(asyncActionFinish());

      callback(promo);
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

export const applyPromoCode = (couponCode, amount, csrfRequestIdentifier, callback) => {
  if (!amount) {
    toastr.error('Error', 'Please enter amount before applying promocode');
    return {
      type: RESET_PROMO_CODE,
      payload: {},
    }
  }
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Applying Promo code . . .', false, 'applypromocode'));
      const URL = `${API.payment.applyPromoCode.url}?couponCode=${couponCode}&amount=${amount}&fcChannel=11`;
      const reqObject = {
        method: API.payment.applyPromoCode.method,
        credentials: 'include',
        mode: 'cors',
        data: JSON.stringify({
          couponCode,
          amount,
        }),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const promo = await fetch(URL, reqObject).then(response => response.json());

      if (promo.errorCode && promo.errors) {
        toastr.error('Promocode Error', promo.errors);
      }

      if (promo.successMsg === 'success') {
        toastr.success('Promocode', 'Promocode applied successfully');
      }

      dispatch({
        type: APPLY_PROMO_CODE,
        payload: promo,
      });
      dispatch(asyncActionFinish());

      callback(promo);
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

export const validatePromoCode = (promoId, payment_option, payment_type, txn_amount, csrfRequestIdentifier, callback) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Validating Promo code . . .', false, 'validatepromocode'));
      const URL = API.payment.validatePromoCode.url;
      const reqObject = {
        method: API.payment.validatePromoCode.method,
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify({
          Source: "FC",
          payment_option,
          payment_type,
          promoId,
          req_channel: "WEB",
          txn_amount,
        }),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const promo = await fetch(URL, reqObject).then(response => response.json());

      if (promo.errorCode && promo.errors) {
        toastr.error('Promocode Validation Error', promo.errors);
      }

      if (promo.successMsg === 'success') {
        toastr.success('Promocode', 'Promocode applied successfully');
      }

      dispatch({
        type: VALIDATE_PROMO_CODE,
        payload: promo,
      });
      dispatch(asyncActionFinish());

      callback(promo);
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};

export const addMoneyInit = (payload, csrfRequestIdentifier, promoId, callback, token) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Initializing payment . . .', true, 'addmoneyinit'));

      // IF promocode applied, append promoId to payload 
      if (promoId && typeof promoId === 'string') {
        payload['promoId'] = promoId;
      }

      const reqObject = {
        method: API.payment.addMoneyInit.method,
        credentials: 'include',
        mode: 'cors',
        body: JSON.stringify(payload),
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
          token,
        }),
      };

      const init = await fetch(API.payment.addMoneyInit.url, reqObject).then(response => response.json());

      dispatch({
        type: ADDMONEY_INIT,
        payload: init,
      });
      dispatch(asyncActionFinish());

      callback(init);
    } catch (error) {
      console.log(error);
      toastr.error('Add Money', 'Error while initializing add money request');
      dispatch(asyncActionError());
    }
  };
};


export const resetPromoCode = () => {
  toastr.success('Promocode Info', 'Promocode was successfully removed');
  return {
    type: RESET_PROMO_CODE,
    payload: {},
  }
}

export const resetFreeFundCode = () => {
  return {
    type: RESET_FREE_FUND_CODE,
    payload: {},
  }
}

export const getWithdrawFeeDetails = (csrfRequestIdentifier, amount) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart('Getting withdraw fee details . . .', false, 'getWithdrawFeeDetails'));

      const reqObject = {
        method: API.payment.getWithdrawFeeDetails.method,
        credentials: 'include',
        mode: 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          csrfRequestIdentifier,
          fcChannel: API.fcChannel,
        }),
      };

      const fee = await fetch(`${API.payment.getWithdrawFeeDetails.url}?amount=${amount}`, reqObject).then(response => response.json());

      dispatch({
        type: GET_WITHDRAW_FEE,
        payload: fee,
      });

      dispatch(asyncActionFinish());

    } catch (error) {
      console.log(error);
      toastr.error('Withdraw to bank', 'Error while getting withdraw fee details!');
      dispatch(asyncActionError());
    }
  };
};

export const deleteWithdrawFee = () => {
  return {
    type: DELETE_WITHDRAW_FEE,
  }
}

export const selectBankAccount = account => {
  return {
    type: SELECT_BANK_ACCOUNT,
    payload: account,
  }
}

export const withdrawSuccess = (_data, _payload, csrfRequestIdentifier, _token) => {

  // Close Modal
  return async dispatch => { 
    dispatch(closeModal());

    // Reset Withdraw Fees and show Enter amount form
    dispatch({
      type: GET_WITHDRAW_FEE,
      payload: {},
    });

    // Withdraw success
    toastr.success("Withdraw To Bank", "Money will be credited soon to your bank account.");
    
    // Refresh balance
    dispatch(getBalance(true, csrfRequestIdentifier));

    dispatch({
      type: WITHDRAW_SUCCESS
    });
  };
}

export const generateOTP = (api, token, payload, csrfRequestIdentifier, callback) => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("Generating OTP...", true, 'generateOTP'));

      let OTP = await axios({
        url: api.url,
        method: api.method,
        data: {...payload},
        headers: {
          'userAgent': navigator.userAgent,
          'Content-type': 'application/json',
          'Accept': 'application/json',
          userMachineIdentifier: 'Linux',
          ipAddress: 'ipAddress',
          host: 'HOST_',
          token,
          csrfRequestIdentifier,
          fcChannel: 11,
        },
      });

      dispatch({
        type: GENERATE_OTP,
        payload: OTP,
      });

      OTP = OTP.data;

      if (!OTP.error || !OTP.errorMessage) {
        callback();
      } else {
        toastr.error('OTP Service', `Error while generating OTP, Internal Server Error!`);
      }
      
      dispatch(asyncActionFinish());

    } catch (error) {
      toastr.error('OTP Service', `Error while generating OTP, Internal Server Error!`);
      console.log(error);
      dispatch(asyncActionError());
    }
  };
}

export const getCardBins = () => {
  return async dispatch => {
    try {
      dispatch(asyncActionStart("Loading...", true, 'cardBins'));
      const reqObject = {
        method: API.payment.cardBins.method,
        credentials: 'include',
        mode: 'cors',
        headers: new Headers({
          'Content-type': 'application/json',
          fcChannel: API.fcChannel,
        }),
      };

      const cardBins = await fetch(API.payment.cardBins.url, reqObject).then(response => response.json());

      dispatch({
        type: CARD_BINS,
        payload: cardBins,
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      console.log(error);
      dispatch(asyncActionError());
    }
  };
};